import React, { useState } from "react";
import { MdClose, MdArrowBackIos } from "../utils/Icons";
import { useFamilyContext } from "../context/FamilyContext";
import { useOrderProcessingContext } from "../context/OrderProcessingContext";
import { calculateAge } from "../utils/DateUtils";

// Imports
import CustomDropdown from "../components/CustomComponents/CustomDropdown";
import CustomSelect from "../components/CustomComponents/CustomSelect";

const options = [
  { value: "self", label: "Self" },
  { value: "grandparents", label: "Grand Parents" },
  { value: "parents", label: "Parents" },
  { value: "spouse", label: "Spouse" },
  { value: "child", label: "Child" },
  { value: "sibling", label: "Sibling" },
];

const AddMemberPopup = ({ closeButton }) => {
  const { familyData, memberData, setMemberData, handleMemberSave } =
    useFamilyContext();
  const { updatePatientAtIndex } = useOrderProcessingContext();
  const [isAddingMember, setIsAddingMember] = useState(false);

  const handleAddingMember = () => {
    setIsAddingMember((prev) => !prev);
  };

  const handleMemberChange = (e) => {
    const { name, value } = e.target;
    setMemberData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleGenderSelect = (gender) => {
    setMemberData((prevState) => ({
      ...prevState,
      gender,
    }));
  };

  return (
    <div className="w-screen h-screen bg-black/25 backdrop-blur flex justify-center items-center p-[3%] fixed left-0 top-0 right-0 bottom-0 z-50">
      <div className="w-full lg:w-[25%] h-full lg:h-[75%] bg-whiteColor flex flex-col justify-start items-center rounded-3xl lg:rounded-3xl p-[2%] lg:p-[1%]">
        <div className="w-full h-fit flex justify-end items-center">
          <button
            className="text-[5vw] lg:text-[1.25vw] text-textPrimaryColor"
            onClick={closeButton}
          >
            <MdClose />
          </button>
        </div>
        <span className="font-semibold text-[4vw] lg:text-[1.25vw] text-textPrimaryColor mb-[3%]">
          Family Member
        </span>
        {isAddingMember && (
          <div className="w-full h-[75%] flex flex-col justify-start items-center border-b px-[5%] space-y-[2%] mb-[2%] overflow-x-hidden overflow-y-scroll scrollbar-hide">
            <div className="w-full h-fit space-y-[3%]">
              <button
                className="flex items-center font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
                onClick={handleAddingMember}
              >
                <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
                <span>Back</span>
              </button>
              <CustomDropdown
                name="relationship"
                value={memberData.relationship}
                options={options}
                onChange={handleMemberChange}
              />
              <div className="w-full h-fit flex flex-col space-y-[2%]">
                <label
                  htmlFor="dob"
                  className="font-normal text-[1vw] text-textSecondaryColor"
                ></label>
                <input
                  type="date"
                  id="dob"
                  name="dob"
                  value={memberData?.dob}
                  onChange={handleMemberChange}
                  max={new Date().toISOString().split("T")[0]}
                  className="input-primary"
                />
              </div>
              <div className="w-full h-fit flex flex-col space-y-[2%]">
                <label
                  htmlFor="name"
                  className="font-normal text-[1vw] text-textSecondaryColor"
                ></label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Mamber Name"
                  value={memberData?.name}
                  onChange={handleMemberChange}
                  maxLength={25}
                  className="input-primary"
                />
              </div>
              <div className="w-full h-fit flex flex-col space-y-[2%]">
                <label
                  htmlFor="contact"
                  className="font-normal text-[1vw] text-textSecondaryColor"
                ></label>
                <input
                  type="number"
                  id="contact"
                  name="contact"
                  placeholder="Mobile Number"
                  value={memberData?.contact}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      handleMemberChange(e);
                    }
                  }}

                  max={9999999999}
                  onKeyDown={(e) => {
                    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  className="input-primary"
                />
              </div>
              <CustomSelect
                dataArray={["male", "female", "other"]}
                onSelect={handleGenderSelect}
                selectedItem={memberData.gender}
              />
            </div>
          </div>
        )}

        {!isAddingMember && familyData?.length > 0 && (
          <div className="w-full h-[75%] flex flex-col justify-start items-center border-b px-[5%] space-y-[3%] mb-[2%] overflow-x-hidden overflow-y-scroll scrollbar-hide">
            {familyData?.map((member, index) => (
              <div
                className="w-full h-fit bg-white border border-accentColor rounded-2xl p-[4%] space-y-[3%] cursor-pointer hover:border-2"
                key={index}
                onClick={() => updatePatientAtIndex(member)}
              >
                <div className="w-full h-fit flex justify-start items-center space-x-[3%]">
                  <span className="font-normal text-[3.5vw] lg:text-[0.9vw] text-accentColor">
                    {member?.name}
                  </span>
                  <span className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textPrimaryColor">
                    {member?.contact}
                  </span>
                </div>
                <div className="w-full h-fit flex justify-start items-center">
                  <span className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textPrimaryColor mr-[1%]">
                    {calculateAge(member?.dob)}
                  </span>
                  <span className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textPrimaryColor mr-[3%]">
                    {member?.gender?.charAt(0).toUpperCase() +
                      member?.gender?.slice(1)}
                  </span>

                  <span className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textPrimaryColor">
                    {member?.relationship?.charAt(0).toUpperCase() +
                      member?.relationship?.slice(1)}
                  </span>
                </div>
                {calculateAge(member?.dob) < 5 && (
                  <p className="font-normal text-[3.25vw] lg:text-[0.8vw] text-[#DB9A39] cursor-pointer mt-[3%]">
                    No home collection for age below 5 years.
                  </p>
                )}
              </div>
            ))}
          </div>
        )}

        {!isAddingMember && familyData?.length === 0 && (
          <div className="w-full h-[75%] flex justify-center items-center">
            <p className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
              No member added yet
            </p>
          </div>
        )}

        {isAddingMember ? (
          <button
            className="btn-primary"
            onClick={() => {
              handleMemberSave(memberData);
              handleAddingMember();
            }}
          >
            Save Member
          </button>
        ) : (
          <button className="btn-primary" onClick={handleAddingMember}>
            Add New Member
          </button>
        )}
      </div>
    </div>
  );
};

export default AddMemberPopup;
